export default __webpack_public_path__ + "static/cookbooks-dc9ff1f7a20188afb60b13b6266e69d3.jpeg";